module.exports = __webpack_public_path__ + "static/media/new_promo_page.fc973139.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/new_promo_page.webp
// module id = 247
// module chunks = 0